import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(public authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      let route = state.url.split('?')[0];
      route = route.replace(/\/\d+/g, '').replace(/\/[a-zA-Z0-9]{24}/g, '');
      console.log(route)
    if (this.authService.hasAccessRoute(route)) {
      return true; // User has access, allow navigation
    } else {
      // User doesn't have access, navigate to a different route or show an error
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
